import {
  Badge,
  BadgeProps,
  Body1Strong,
  Link as FluentLink,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Tooltip,
} from '@fluentui/react-components';
import { DateLabel } from '@shared/components';
import { UserLabel } from '@modules/users';
import {
  EPeriodicReviewOutcome,
  PERIODIC_REVIEW_OUTCOME_LABELS,
  TPeriodicReviewHistoryEntry,
} from '../../types/periodicReviews.types';

type TProps = {
  history: TPeriodicReviewHistoryEntry[];
  onViewVersion: (versionId: string) => void;
};

const outcomeColor: Record<EPeriodicReviewOutcome, BadgeProps['color']> = {
  [EPeriodicReviewOutcome.NO_CHANGES_REQUIRED]: 'brand',
  [EPeriodicReviewOutcome.CHANGES_REQUIRED]: 'danger',
};

const PeriodicReviewHistoryTable = ({ history, onViewVersion }: TProps) => {
  const rows = [...history].sort((a, b) => new Date(b.reviewDate).getTime() - new Date(a.reviewDate).getTime());

  if (rows.length === 0) return <p className="text-neutral-500">No reviews completed yet.</p>;

  return (
    <Table style={{ tableLayout: 'fixed', width: '100%' }}>
      <TableHeader>
        <TableRow>
          <TableHeaderCell style={{ width: '130px' }}>
            <Body1Strong>Review date</Body1Strong>
          </TableHeaderCell>
          <TableHeaderCell style={{ width: '90px' }}>
            <Body1Strong>Version</Body1Strong>
          </TableHeaderCell>
          <TableHeaderCell style={{ width: '170px' }}>
            <Body1Strong>Reviewer</Body1Strong>
          </TableHeaderCell>
          <TableHeaderCell style={{ width: '170px' }}>
            <Body1Strong>Outcome</Body1Strong>
          </TableHeaderCell>
          <TableHeaderCell>
            <Body1Strong>Review note</Body1Strong>
          </TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row._id}>
            <TableCell>
              <DateLabel short>{row.reviewDate}</DateLabel>
            </TableCell>
            <TableCell>
              <FluentLink onClick={() => onViewVersion(row.version)}>{`v${row.version}`}</FluentLink>
            </TableCell>
            <TableCell>
              <UserLabel id={row.reviewer} className="block truncate" />
            </TableCell>
            <TableCell>
              <Badge appearance="tint" color={outcomeColor[row.outcome]}>
                {PERIODIC_REVIEW_OUTCOME_LABELS[row.outcome]}
              </Badge>
            </TableCell>
            <TableCell>
              {row.note ? (
                <Tooltip relationship="description" content={<p className="whitespace-break-spaces">{row.note}</p>}>
                  <span className="block max-w-full whitespace-nowrap text-ellipsis overflow-hidden">{row.note}</span>
                </Tooltip>
              ) : (
                '-'
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PeriodicReviewHistoryTable;
